import { CameraIcon } from '../../../../../assets/icons/common';
import styles from './style.module.scss';

interface Props {
    kycStatus: string;
    facePhoto: string | null;
};

export default function Identifying(props: Props) {
    const { facePhoto, kycStatus } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Personal photo</span>
                </div>
                <div className={styles.content_main}>
                    {facePhoto ? <div className={styles.content_main_face}>
                        <img src={facePhoto} alt='' />
                    </div> : <div className={styles.content_main_empty}>
                        <CameraIcon />
                        <span>No data</span>
                    </div>}
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>KYC status</span>
                    <div className={styles.content_headbar_actions}>

                    </div>
                </div>
                <div className={styles.content_main}>
                    <span
                        className={styles.content_main_status}
                        data-kyc-status={kycStatus}
                    >
                        {kycStatus === 'approved' && 'Approved'}
                        {kycStatus === 'notApproved' && 'Not approved'}
                    </span>
                </div>
            </div>
        </div>
    );
};